import { WORKSPACE_AGENT_MUTATION_TOOL_NAMES, type WorkspaceAgentMutationToolName } from '@air/analytics';

import { type ToolCall } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/toolCallMetadata';
import { parseToolResultMetadata } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/toolResultMetadata';
import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';
import { workspaceAgentMessageShouldInvalidateCaches } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentMessageShouldInvalidateCaches';

const workspaceAgentMutationToolNameSet = new Set<string>(WORKSPACE_AGENT_MUTATION_TOOL_NAMES);

const isWorkspaceAgentMutationToolName = (toolName: string): toolName is WorkspaceAgentMutationToolName =>
  workspaceAgentMutationToolNameSet.has(toolName);

/** Resolves a mutating tool name from metadata and paired toolCall rows. Does not gate on success. */
export const resolveWorkspaceAgentMutatingToolName = (
  toolResultMessage: WorkspaceAgentMessage,
  toolCallById: Map<string, ToolCall>,
): WorkspaceAgentMutationToolName | undefined => {
  const result = parseToolResultMetadata(toolResultMessage.metadata);

  if (result?.outcome !== 'readable') {
    return undefined;
  }

  const pairedToolCall = toolCallById.get(result.metadata.toolCallId);
  const toolName = pairedToolCall?.name ?? result.metadata.toolName;

  if (!toolName || !isWorkspaceAgentMutationToolName(toolName)) {
    return undefined;
  }

  if (!workspaceAgentMessageShouldInvalidateCaches(toolResultMessage)) {
    return undefined;
  }

  return toolName;
};
